import { observer } from 'mobx-react';
import { useStores } from 'hooks/useStores';
import * as S from './styles'
import {Button, Variant} from "../../../Button";
import {Uppercase} from "../../../../styles/components";

export const Feedback = observer(() => {

  const { businessStore } = useStores()

  return (
    <S.Container>
        <S.LargeScreen>
            <S.Content>
                <S.TextBlock>
                    <div>
                        <S.Title>
                            У Вас есть вопрос, комментарий или предложение?
                        </S.Title>
                        <S.Text>
                            Для получения дополнительной информации, пожалуйста, заполните контактную форму и мы свяжемся с вами в ближайшее время
                        </S.Text>
                    </div>
                    <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}><Uppercase>Связаться с нами</Uppercase></Button>
                </S.TextBlock>
                <div>
                  <S.ImageBlock/>
                </div>
            </S.Content>
        </S.LargeScreen>
        <S.SmallScreen>
            <S.Content>
                <S.Title>
                    У Вас есть вопрос, комментарий или предложение?
                </S.Title>
                <S.Block>
                    <S.Text>
                        Для получения дополнительной информации, пожалуйста, заполните контактную форму и мы свяжемся с вами в ближайшее время
                    </S.Text>
                    <S.ImageBlock/>
                </S.Block>
                <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}><Uppercase>Связаться с нами</Uppercase></Button>
            </S.Content>
        </S.SmallScreen>
    </S.Container>
  )
})